import { useMemo } from "react";
import styles from "./LowerContentBlock.module.css";

export const LowerContentBlock = ({
    lowerContentBlockText,
    fromOffersPage,
    maxWidth,
}: {
    lowerContentBlockText: string;
    fromOffersPage?: boolean;
    maxWidth?: number;
}) => {
    const normalizedContent = useMemo(() => {
        if (!lowerContentBlockText) return '';
        
        return lowerContentBlockText
            .replace(/\s+/g, ' ')
            .replace(/\n/g, '')
            .replace(/style="([^"]*)"/, (match, styles) => {
                return `style="${styles.trim().replace(/\s*:\s*/g, ':').replace(/\s*;\s*/g, ';')}"`;
            })
            .trim();
    }, [lowerContentBlockText]);
    
    return (
        <div
            className={styles.contentParentOuter}
            style={{ maxWidth: maxWidth, margin: "auto" }}
        >
            <div
                className={
                    fromOffersPage
                        ? `${styles.contentOuter} ${styles.offerStyles}`
                        : `${styles.contentOuter}`
                }
                style={{ maxWidth: maxWidth, margin: "auto" }}
            >
                <div
                    className={styles.content}
                    dangerouslySetInnerHTML={{
                        __html: normalizedContent,
                    }}
                ></div>
            </div>
        </div>
    );
};
